module.exports = __webpack_public_path__ + "static/media/icon_onSuccess.6fc6bdd9.svg";